import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Quiz from "./pages/Quiz";
import Results from "./pages/Results";
import SelectQuiz from "./pages/SelectQuiz";
import Register from "./pages/Register";
import { AuthProvider, useAuthContext } from "./pages/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";

// Componente de rota protegida
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuthContext();
  return currentUser ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Rotas públicas */}
          <Route path="/" element={<><Navbar /><Home /></>} />
          <Route path="/login" element={<><Navbar /><Login /></>} />
          <Route path="/register" element={<><Navbar /><Register /></>} />
          <Route path="/quiz/:quizKey" element={<><Navbar /><Quiz /></>} />

          {/* Rota para seleção de quiz */}
          <Route
            path="/selectquiz"
            element={
              <ProtectedRoute>
                <><Navbar /><SelectQuiz /></>
              </ProtectedRoute>
            }
          />

          {/* Rotas protegidas */}
          <Route
            path="/quiz"
            element={
              <ProtectedRoute>
                <><Navbar /><Quiz /></>
              </ProtectedRoute>
            }
          />
          <Route
            path="/results"
            element={
              <ProtectedRoute>
                <><Navbar /><Results /></>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
